export enum GeoJsonType {
  POINT = 'Point',
  POLYGON = 'Polygon'
}
